import React, { useState } from 'react';
import {
  MessageCircle,
  Shield,
  Heart,
  Users,
  Star,
  Award,
  Phone,
  Mail,
  MapPin,
  Clock,
  Send,
  CheckCircle,
  Building2,
  Handshake,
  Target,
  Eye,
  Calendar
} from 'lucide-react';
import './Nosotros.css';
import baseURL from '../url';
import Navbar from '../Navbar/Navbar';

// ----------------------------------------------------
// 💡 CORRECCIÓN DE IMAGEN: Importar la imagen como un módulo.
// Ajusta la ruta (../../images/motosnosotros.jpg) si es necesario.
import heroImage from '../../images/motosnosotros.jpg';
// ----------------------------------------------------


const Nosotros = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    email: '',
    telefono: '',
    mensaje: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleWhatsAppClick = () => {
    const phoneNumber = "5491134567890"; // Reemplazar con el número real
    const message = "Hola! Me gustaría conocer más sobre R20 MOTOS y sus servicios.";
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      // Crear FormData para enviar los datos
      const formDataToSend = new FormData();
      formDataToSend.append('nombre', formData.nombre);
      formDataToSend.append('apellido', formData.apellido);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('telefono', formData.telefono);
      formDataToSend.append('mensaje', formData.mensaje);

      const response = await fetch(`${baseURL}/clientPost.php`, {
        method: 'POST',
        body: formDataToSend
      });

      const result = await response.json();

      if (response.ok && !result.error) {
        setSubmitMessage('¡Gracias por tu mensaje! Te contactaremos pronto.');
        // Limpiar el formulario
        setFormData({
          nombre: '',
          apellido: '',
          email: '',
          telefono: '',
          mensaje: ''
        });
      } else {
        setSubmitMessage(result.error || 'Ocurrió un error al enviar el mensaje. Por favor, intenta nuevamente.');
      }
    } catch (error) {
      console.error('Error al enviar el formulario:', error);
      setSubmitMessage('Error de conexión. Por favor, verifica tu conexión e intenta nuevamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const teamMembers = [
    { name: "Roberto Filoni", role: "Director General", image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face" },
    { name: "María González", role: "Gerente de Ventas", image: "https://images.unsplash.com/photo-1494790108755-2616b6bb48fd?w=400&h=400&fit=crop&crop=face" },
    { name: "Carlos Mendez", role: "Asesor Senior", image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face" },
    { name: "Ana Ruiz", role: "Especialista en Financiación", image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&crop=face" }
  ];

  return (

    <div className="nosotros-page">
      {/* Hero Section */}
      {/* Navbar agregado aquí */}
      <Navbar />
      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1>R20 MOTOS</h1>
              <h2>Concesionario oficial </h2>
              <p className="description">
                Somos parte de Grupo Antun, junto a marcas líderes como Chexa y Turín.
                Ofrecemos el mejor servicio de venta de motos, con atención personalizada, financiamiento accesible y el respaldo de una trayectoria sólida en el rubro automotor.
              </p>

              <div className="stats">
                <div className="stat-item">
                  <div className="stat-number">98%</div>
                  <div className="stat-label">Clientes satisfechos</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">Respaldo</div>
                  <div className="stat-label"> De Marcas lideres</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">Trayectoria</div>
                  <div className="stat-label">Más de 30 años en el rubro</div>
                </div>
              </div>
            </div>

            <div className="hero-image">
              <img
                // ✅ RUTA CORREGIDA: Usamos la variable importada
                src={heroImage}
                alt="Local R20 MOTOS"
                className="hero-img"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Valores */}
      <section className="values-section">
        <div className="container">
          <h2 className="section-title">NUESTROS VALORES</h2>

          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <Shield className="icon" />
              </div>
              <h3>Compromiso</h3>
              <p>
                Nos esforzamos cada día para brindar un servicio ágil, confiable y de calidad, acompañando a cada cliente durante todo el proceso de compra.

              </p>

            </div>

            <div className="value-card">
              <div className="value-icon">
                <Handshake className="icon" />
              </div>
              <h3>Calidad</h3>
              <p>
                Seleccionamos cuidadosamente cada unidad y trabajamos con marcas líderes para garantizar productos seguros, duraderos y con respaldo oficial.

              </p>

            </div>

            <div className="value-card">
              <div className="value-icon">
                <Heart className="icon" />
              </div>
              <h3>Cercanía</h3>
              <p>
                Nos caracteriza la atención humana y directa. Escuchamos tus necesidades y te asesoramos de manera personalizada para que encuentres tu moto ideal.

              </p>

            </div>
          </div>
        </div>
      </section>


      {/* Formulario de Contacto */}
      <section className="contact-section">
        <div className="container">
          <div className="contact-content">
            <div className="contact-info">
              <h2>¿TENES ALGUNA CONSULTA?</h2>
              <p>Estamos acá para ayudarte. Completá el formulario y nos pondremos en contacto con vos.</p>

              <div className="contact-details">
                <div className="contact-item">
                  <MapPin className="contact-icon" />
                  <div>
                    <strong>Dirección</strong>
                    <p>Av Fuerza Aérea 3850, Córdoba, Argentina</p>
                  </div>
                </div>
                <div className="contact-item">
                  <Phone className="contact-icon" />
                  <div>
                    <strong>Teléfono</strong>
                    <p>+54 9 3513 47-5771</p>
                  </div>
                </div>
                <div className="contact-item">
                  <Mail className="contact-icon" />
                  <div>
                    <strong>Email</strong>
                    <p>motos.comercial@grupoantun.com.ar</p>
                  </div>
                </div>
              </div>
            </div>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="nombre">Nombre</label>
                <input
                  type="text"
                  id="nombre"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleInputChange}
                  required
                  placeholder="Tu nombre completo"
                />
              </div>
              <div className="form-group">
                <label htmlFor="nombre">Apellido</label>
                <input
                  type="text"
                  id="apellido"
                  name="apellido"
                  value={formData.apellido}
                  onChange={handleInputChange}
                  required
                  placeholder="Tu apellido"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  placeholder="tu.email@ejemplo.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="telefono">Teléfono</label>
                <input
                  type="tel"
                  id="telefono"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleInputChange}
                  placeholder="(011) 1234-5678"
                />
              </div>

              <div className="form-group">
                <label htmlFor="mensaje">Mensaje</label>
                <textarea
                  id="mensaje"
                  name="mensaje"
                  value={formData.mensaje}
                  onChange={handleInputChange}
                  required
                  rows="5"
                  placeholder="Contanos tu consulta..."
                ></textarea>
              </div>

              <button
                type="submit"
                className="submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>Enviando...</>
                ) : (
                  <>
                    <Send className="btn-icon" />
                    Enviar mensaje
                  </>
                )}
              </button>

              {submitMessage && (
                <div className="success-message">
                  <CheckCircle className="success-icon" />
                  {submitMessage}
                </div>
              )}
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Nosotros;